import { render, staticRenderFns } from "./PagePlacesCategories.vue?vue&type=template&id=3c437daa&"
import script from "./PagePlacesCategories.vue?vue&type=script&lang=js&"
export * from "./PagePlacesCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c437daa')) {
      api.createRecord('3c437daa', component.options)
    } else {
      api.reload('3c437daa', component.options)
    }
    module.hot.accept("./PagePlacesCategories.vue?vue&type=template&id=3c437daa&", function () {
      api.rerender('3c437daa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/placesCategories/PagePlacesCategories.vue"
export default component.exports